import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import Swal from 'sweetalert2';
import { FaCalendarAlt, FaTicketAlt, FaMoneyBillWave } from 'react-icons/fa';

export default function Home() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await api.get('/events');

                // بنحاول نجيب الداتا من أي مسار محتمل
                let fetchedEvents = response.data?.data || response.data || [];

                // تأمين إضافي: لو اللي رجع مش مصفوفة، هنخليه مصفوفة فاضية عشان نمنع الشاشة البيضاء
                if (!Array.isArray(fetchedEvents)) {
                    console.error("API did not return an array. It returned:", fetchedEvents);
                    fetchedEvents = [];
                }

                setEvents(fetchedEvents);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching events:", error);
                Swal.fire('Error', 'Unable to fetch events. Is the server running?', 'error');
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    const handleBook = async (eventId) => {
        const token = localStorage.getItem('token');

        if (!token) {
            Swal.fire({
                icon: 'warning',
                title: 'Access Denied',
                text: 'You need to login first to book a ticket!',
                confirmButtonText: 'Go to Login',
                confirmButtonColor: '#3085d6',
            }).then(() => {
                navigate('/login');
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Securing your ticket...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const response = await api.post(`/events/${eventId}/reserve`);

            Swal.fire({
                icon: 'success',
                title: 'Ticket Reserved!',
                text: 'Your ticket is secured for 5 minutes. Please complete payment.',
                confirmButtonText: 'Pay Now 💳',
                confirmButtonColor: '#28a745'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        Swal.fire({
                            title: 'Processing Payment...',
                            allowOutsideClick: false,
                            didOpen: () => Swal.showLoading()
                        });

                        await api.post(`/orders/${response.data.order_id}/pay`);

                        Swal.fire({
                            icon: 'success',
                            title: 'Payment Successful! 🎉',
                            text: 'Your ticket is now confirmed.',
                            timer: 2000,
                            showConfirmButton: false
                        }).then(() => {
                            navigate('/my-tickets');
                        });

                    } catch (paymentError) {
                        Swal.fire('Error', 'Payment failed. Please try again.', 'error');
                    }
                }
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response?.data?.message || 'Failed to book. Tickets might be sold out.'
            });
        }
    };

    if (loading) {
        return <div className="mt-5 text-center"><h4 className="text-muted">Loading Awesome Events... ⏳</h4></div>;
    }

    return (
        <div className="container mt-5">
            <div className="text-center mb-5 fade-in-up">
                <h2 className="fw-bold text-dark">Upcoming Events 🎟️</h2>
                <p className="text-muted">Discover and book tickets for the best events around the world.</p>
            </div>

            <div className="row">
                {/* السحر هنا: تأكيد إن events عبارة عن مصفوفة قبل استخدام map */}
                {Array.isArray(events) && events.length > 0 ? (
                    events.map((event, index) => (
                        <div
                            className="col-md-4 mb-4 fade-in-up"
                            key={event.id}
                            style={{ animationDelay: `${index * 0.15}s` }}
                        >
                            <div className="card event-card h-100 p-2">
                                <div className="card-body p-4">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <h5 className="card-title text-dark fw-bold mb-0 lh-base">{event.title}</h5>
                                    </div>

                                    <hr className="text-muted opacity-25" />

                                    <div className="card-text text-secondary mb-4 mt-3">
                                        <div className="d-flex align-items-center mb-3">
                                            <FaCalendarAlt className="text-primary me-3 fs-5" />
                                            <span>{new Date(event.event_date).toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                        </div>
                                        <div className="d-flex align-items-center mb-3">
                                            <FaMoneyBillWave className="text-success me-3 fs-5" />
                                            <span className="fw-bold text-success fs-5">${event.ticket_price}</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <FaTicketAlt className="text-warning me-3 fs-5" />
                                            <span>{event.total_tickets} Tickets Left</span>
                                        </div>
                                    </div>

                                    <button
                                        className="btn btn-gradient w-100 shadow-sm mt-2"
                                        onClick={() => handleBook(event.id)}
                                    >
                                        Book Ticket
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center fade-in-up">
                        <p className="text-muted fs-5">No events available at the moment.</p>
                    </div>
                )}
            </div>
        </div>
    );
}